//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Constants } from '../../common/Constants';
import { IHttpInfo } from '../../logger';
import { newGuid } from '../../utilities/AppUtils';
import { AuthHelper } from '../../utilities/AuthHelper';
import { getAppHost } from '../../utilities/TeamsUtils';
import { tryParseAfdRefHeader } from '../../utilities/Utils';
import { HandleChallengeClaims } from '../ErrorHandling/HandleChallengeClaims';
export class TemplatesBaseClient {
    readonly clientRequestIdHeader = Constants.CLIENT_REQUESTID_HEADER;
    private startTime: number;
    private requestId: string;
    private method: string;
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = options.headers as any;
        headers.authorization = 'Bearer ' + (await AuthHelper.getApprovalsToken());
        this.startTime = performance.now();
        if (!headers[this.clientRequestIdHeader]) {
            // set the clientRequestId if it's not present.
            headers[this.clientRequestIdHeader] = newGuid();
        }

        this.requestId = headers[this.clientRequestIdHeader];
        this.method = options.method;
        return Promise.resolve(options);
    }
    protected async transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ): Promise<any> {
        const status = response ? response.status : 0;
        const edgeRef = tryParseAfdRefHeader(response);
        if (status >= 400 || status < 200) {
            console.error(`Server request failed, url: ${url}, status ${status}`);
            await HandleChallengeClaims(response);
        }
        const regex = /\/templates\/v1.0\/([a-zA-Z0-9]+)/;
        const apiName = url.match(regex)[0].toString();
        // TODO: add host name
        const httpRequest: IHttpInfo = {
            apiName,
            url,
            clientRequestId: this.requestId,
            correlationId: this.requestId,
            latency: performance.now() - this.startTime,
            requestCreatedTime: this.startTime.toString(),
            responseCode: status,
            responseText: response.statusText,
            requestMethod: this.method,
            edgeRef,
        };
        getAppHost().getLogger().logHttp(httpRequest);
        return await processor(response);
    }
    protected getBaseUrl(token: string, baseUrl: string): string {
        return baseUrl ? baseUrl : TEMPLATES_SERVICE_ENDPOINT;
    }
}

export class CheckAdminGroupExistingClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Check if the admin group id exist.
     * @return True for exist,False for not exist.
     */
    checkAdminGroupExisting(): Promise<boolean> {
        let url_ = this.baseUrl + "/templates/v1.0/CheckAdminGroupExisting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckAdminGroupExisting(_response));
        });
    }

    protected processCheckAdminGroupExisting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CheckAdminGroupStateClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Check if the admin group id exist.
     * @return True for exist,False for not exist.
     */
    checkAdminGroupExisting(): Promise<AdminGroupState> {
        let url_ = this.baseUrl + "/templates/v1.0/CheckAdminGroupExistAndWork";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckAdminGroupExisting(_response));
        });
    }

    protected processCheckAdminGroupExisting(response: Response): Promise<AdminGroupState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminGroupState;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminGroupState>(null as any);
    }
}

export class CheckUserInAdminTeamClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Check if current user in admin team.
     * @return 200 for success.
     */
    checkUserInAdminTeam(): Promise<boolean> {
        let url_ = this.baseUrl + "/templates/v1.0/CheckUserInAdminTeam";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckUserInAdminTeam(_response));
        });
    }

    protected processCheckUserInAdminTeam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CheckUserInGroupsClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Check if current user in one team.
     * @param groupIds (optional) The groups to check.
     * @return true if is member of one group ,otherwise false.
     */
    checkUserInGroups(groupIds: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/templates/v1.0/CheckUserInGroups?";
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckUserInGroups(_response));
        });
    }

    protected processCheckUserInGroups(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CreateApprovalFormClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Create approval form according to TemplateId or create an empty form if TemplateId is not provided.
     * @param input he controller input.
     * @return Id of new created form.
     */
    createApprovalForm(input: CreateApprovalFormInput): Promise<CreateApprovalFormOutput> {
        let url_ = this.baseUrl + "/templates/v1.0/CreateApprovalForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateApprovalForm(_response));
        });
    }

    protected processCreateApprovalForm(response: Response): Promise<CreateApprovalFormOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApprovalFormOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApprovalFormOutput>(null as any);
    }
}

export class CreateApprovalTemplateInstanceClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * API to create approval template instance.
     * @param input the post body.
     * @return created approval template instance.
     */
    createApprovalTemplateInstance(input: CreateApprovalTemplateInstanceInput): Promise<ApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/CreateTemplateInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateApprovalTemplateInstance(_response));
        });
    }

    protected processCreateApprovalTemplateInstance(response: Response): Promise<ApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplateInstance>(null as any);
    }

    /**
     * API to create approval template instance from self owned design time.
     * @param input the post body.
     * @return created approval template instance.
     */
    createSelfOwnedApprovalTemplateInstance(input: CreateSelfOwnedApprovalTemplateInstanceInput): Promise<SelfOwnedApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/CreateSelfOwnedApprovalTemplateInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSelfOwnedApprovalTemplateInstance(_response));
        });
    }

    protected processCreateSelfOwnedApprovalTemplateInstance(response: Response): Promise<SelfOwnedApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelfOwnedApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelfOwnedApprovalTemplateInstance>(null as any);
    }
}

export class CreateConsistencyAdminGroupClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Create a  Consistency admin group (not team).
     * @return CreateAdminGroupOutput instance.
     */
    createConsistencyAdminGroup(): Promise<CreateAdminGroupOutput> {
        let url_ = this.baseUrl + "/templates/v1.0/CreateConsistencyAdminGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateConsistencyAdminGroup(_response));
        });
    }

    protected processCreateConsistencyAdminGroup(response: Response): Promise<CreateAdminGroupOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdminGroupOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdminGroupOutput>(null as any);
    }
}

export class GetApprovalTemplateInstanceDetailsClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get ApprovalTemplateInstance details by Id.
     * @param id the instance Id.
     * @param scenario (optional) the scenario of the action.
     * @return the ApprovalTemplateInstance found by Id.
     */
    getApprovalTemplateInstanceDetails(id: string, scenario: GetApprovalTemplateInstanceDetailsScenario | undefined): Promise<ApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/GetApprovalTemplateDetails?";
        if (scenario === null)
            throw new Error("The parameter 'scenario' cannot be null.");
        else if (scenario !== undefined)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApprovalTemplateInstanceDetails(_response));
        });
    }

    protected processGetApprovalTemplateInstanceDetails(response: Response): Promise<ApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplateInstance>(null as any);
    }

    /**
     * Get ApprovalTemplateInstance details by Id.
     * @param id the instance Id.
     * @param scenario (optional) the scenario of the action.
     * @return the SelfOwnedApprovalTemplateInstance found by Id.
     */
    getSelfOwnedApprovalTemplateInstanceDetails(id: string, scenario: GetApprovalTemplateInstanceDetailsScenario | undefined): Promise<SelfOwnedApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/GetSelfOwnedApprovalTemplateDetails?";
        if (scenario === null)
            throw new Error("The parameter 'scenario' cannot be null.");
        else if (scenario !== undefined)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelfOwnedApprovalTemplateInstanceDetails(_response));
        });
    }

    protected processGetSelfOwnedApprovalTemplateInstanceDetails(response: Response): Promise<SelfOwnedApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelfOwnedApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelfOwnedApprovalTemplateInstance>(null as any);
    }
}

export class GetTemplatePromotionClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get current promition information.
     * @return Promotion infomationPromotionInfo .
     */
    getTemplatePromotion(): Promise<PromotionInfo[]> {
        let url_ = this.baseUrl + "/templates/v1.0/GetTemplatePromotion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTemplatePromotion(_response));
        });
    }

    protected processGetTemplatePromotion(response: Response): Promise<PromotionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PromotionInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotionInfo[]>(null as any);
    }
}

export class GetUserProfileClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the UserProfile.
     * @return The UserProfile.
     */
    getUserProfile(): Promise<UserProfile> {
        let url_ = this.baseUrl + "/templates/v1.0/UserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserProfile(_response));
        });
    }

    protected processGetUserProfile(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(null as any);
    }
}

export class ListApprovalDefaultTemplatesClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List all default ApprovalTemplate.
     * @param locale (optional) locale info.
     * @return the list of ApprovalTemplate.
     */
    listApprovalDefaultTemplates(locale: string | null | undefined): Promise<ApprovalTemplate[]> {
        let url_ = this.baseUrl + "/templates/v1.0/ListApprovalDefaultTemplates?";
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListApprovalDefaultTemplates(_response));
        });
    }

    protected processListApprovalDefaultTemplates(response: Response): Promise<ApprovalTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplate[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplate[]>(null as any);
    }
}

export class ListOrgApprovalTemplateInstancesClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List all ApprovalTemplateInstance in current user's organization.
     * @param scenario (optional) The scenario of the listing action.
     * @return the list of ApprovalTemplateInstance.
     */
    listOrgApprovalTemplateInstances(scenario: ListApprovalTemplateInstancesScenario | undefined): Promise<ApprovalTemplateInstance[]> {
        let url_ = this.baseUrl + "/templates/v1.0/ListTenantApprovalTemplateInstances?";
        if (scenario === null)
            throw new Error("The parameter 'scenario' cannot be null.");
        else if (scenario !== undefined)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListOrgApprovalTemplateInstances(_response));
        });
    }

    protected processListOrgApprovalTemplateInstances(response: Response): Promise<ApprovalTemplateInstance[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplateInstance[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplateInstance[]>(null as any);
    }
}

export class ListTeamApprovalTemplateInstancesClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * List all ApprovalTemplateInstance in a team.
     * @param teamId (optional) id of the team.
     * @param scenario (optional) The scenario of the listing action.
     * @return the list of ApprovalTemplateInstance.
     */
    listTeamApprovalTemplateInstances(teamId: string | undefined, scenario: ListApprovalTemplateInstancesScenario | undefined): Promise<ApprovalTemplateInstance[]> {
        let url_ = this.baseUrl + "/templates/v1.0/ListTeamApprovalTemplateInstances?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (scenario === null)
            throw new Error("The parameter 'scenario' cannot be null.");
        else if (scenario !== undefined)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListTeamApprovalTemplateInstances(_response));
        });
    }

    protected processListTeamApprovalTemplateInstances(response: Response): Promise<ApprovalTemplateInstance[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplateInstance[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplateInstance[]>(null as any);
    }

    /**
     * List team scoped template instances in batch mode.
     * @param input The input containing the ids of teams, maximum 10 teams allowed.
     * @return The output containing the response of each team.
     */
    listTeamApprovalTemplateInstancesBatch(input: ListTeamApprovalTemplateInstancesBatchInput): Promise<ListTeamApprovalTemplateInstancesBatchOutput> {
        let url_ = this.baseUrl + "/templates/v1.0/ListTeamApprovalTemplateInstances/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListTeamApprovalTemplateInstancesBatch(_response));
        });
    }

    protected processListTeamApprovalTemplateInstancesBatch(response: Response): Promise<ListTeamApprovalTemplateInstancesBatchOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListTeamApprovalTemplateInstancesBatchOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListTeamApprovalTemplateInstancesBatchOutput>(null as any);
    }
}

export class PeoplePickerClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the users and groups searching result by the user input query text.
     * @param input The user input.
     * @return The user and group results.
     */
    getTenantUsersAndGroups(input: PeopleResultsControllerInput): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/templates/v1.0/GetTenantUsersAndGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTenantUsersAndGroups(_response));
        });
    }

    protected processGetTenantUsersAndGroups(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }
}

export class ReCreateConsistencyAdminGroupClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Remove old admin group setting and create a new group (not team).
     * @return CreateAdminGroupOutput instance.
     */
    createConsistencyAdminGroup(): Promise<CreateAdminGroupOutput> {
        let url_ = this.baseUrl + "/templates/v1.0/ReCreateConsistencyAdminGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateConsistencyAdminGroup(_response));
        });
    }

    protected processCreateConsistencyAdminGroup(response: Response): Promise<CreateAdminGroupOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdminGroupOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdminGroupOutput>(null as any);
    }
}

export class UpdateApprovalTemplateInstanceClient extends TemplatesBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Update ApprovalTemplateInstance.
     * @param input the body input.
     * @return the updated ApprovalTemplateInstance.
     */
    updateApprovalTemplateInstance(input: UpdateApprovalTemplateInstanceInput): Promise<ApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/UpdateApprovalTemplateInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateApprovalTemplateInstance(_response));
        });
    }

    protected processUpdateApprovalTemplateInstance(response: Response): Promise<ApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalTemplateInstance>(null as any);
    }

    /**
     * Update SelfOwnedApprovalTemplateInstance.
     * @param input the body input.
     * @return the updated SelfOwnedApprovalTemplateInstance.
     */
    updateSelfOwnedApprovalTemplateInstance(input: UpdateSelfOwnedApprovalTemplateInstanceInput): Promise<SelfOwnedApprovalTemplateInstance> {
        let url_ = this.baseUrl + "/templates/v1.0/UpdateSelfOwnedApprovalTemplateInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSelfOwnedApprovalTemplateInstance(_response));
        });
    }

    protected processUpdateSelfOwnedApprovalTemplateInstance(response: Response): Promise<SelfOwnedApprovalTemplateInstance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelfOwnedApprovalTemplateInstance;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelfOwnedApprovalTemplateInstance>(null as any);
    }
}

/** Represents the status of the Admin group. */
export enum AdminGroupState {
    NotCreated = 0,
    Exist = 1,
    Corrupt = 2,
    Unknown = 3,
}

/** Body output when calling CreateApprovalForm controller. */
export interface CreateApprovalFormOutput {
    /** Gets or sets the id of the approval form. */
    Id?: string | undefined;
}

/** Body input when calling CreateApprovalForm controller. */
export interface CreateApprovalFormInput {
    /** Gets or sets the id of the default template. */
    TemplateId?: string | undefined;
    /** Gets or sets the locale info. */
    Locale?: string | undefined;
    /** Gets or sets the scope of the form. */
    Scope: ApprovalTemplateInstanceScopeType;
    /** Gets or sets the teamId of the form. */
    TeamId?: string | undefined;
}

/** The enum definition of ApprovalTemplateInstance scope. */
export enum ApprovalTemplateInstanceScopeType {
    Organization = 0,
    Team = 1,
}

/** Data object of Approval template instance. */
export interface BaseApprovalTemplateInstance {
    /** Gets or sets the Id of the template instance. this Id would include SDS shard info and would be encoded into base64url format. */
    Id?: string | undefined;
    /** Gets or sets the title of the template instance. */
    Title?: string | undefined;
    /** Gets or sets the description of the template instance. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the template instance. */
    IconName?: string | undefined;
    /** Gets or sets the icon color of the template instance. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the template instance. */
    Category: ApprovalTemplateCategory;
    /** Gets or sets the scope of the template instance. */
    Scope: ApprovalTemplateInstanceScopeType;
    /** Gets or sets the teamId of the template instance. this is actually the groupId of the team, and this field is only for Team scoped template instances. */
    TeamId?: string | undefined;
    /** Gets or sets a value indicating whether the template instance is enabled. */
    IsEnabled: boolean;
    /** Gets or sets a value indicating whether the template instance is visible to all organization users, this property is ignored for team scoped template instances. */
    IsVisibleToAll: boolean;
    /** Gets or sets the principals to which the template instance is visible, this field is only for Organization scoped template instances. */
    VisibleTo?: VisibilityPrincipal[] | undefined;
    /** Gets or sets the WorkflowSchema. */
    WorkflowSchema?: WorkflowSchema | undefined;
    /** Gets or sets the user who created the template instance. */
    CreatedBy?: PeopleResult | undefined;
    /** Gets or sets the timestamp when the template instance is created. */
    CreatedAt: string;
    /** Gets or sets the user who last modified the template instance. */
    LastModifiedBy?: PeopleResult | undefined;
    /** Gets or sets the timestamp when the template instance is last modified. */
    LastModifiedAt: string;
    /** Gets or sets a value indicating whether the file attachment is required. */
    IsFileAttachmentRequired: boolean;
    /** Gets or sets whether the requests created by this template requires approvers comments, default to null. */
    IsApproverCommentsRequired?: boolean | undefined;
}

/** Data object of Approval template instance. */
export interface ApprovalTemplateInstance extends BaseApprovalTemplateInstance {
    /** Gets or sets the Id of form. */
    FormId?: string | undefined;
}

/** The enum definition of categories of ApprovalTemplateInstance. */
export enum ApprovalTemplateCategory {
    NotSpecified = 0,
    Attendance = 1,
    Administration = 2,
    Finance = 3,
    Activity = 4,
    OrderManagement = 5,
    Personnel = 6,
    Contract = 7,
    HealthCare = 8,
    WordAddin = 9,
}

/** Data object of the visibility principal definition. */
export interface VisibilityPrincipal {
    /** Gets or sets the id of the principal.
AadObjectId for User and Group
Guid.Empty for Everyone. */
    PrincipalId: string;
    /** Gets or sets the principal type. */
    PrincipalType: VisibilityPrincipalType;
    /** Gets or sets the display name of the pricipal. String.Empty for 'Everyone'. */
    DisplayName?: string | undefined;
}

/** The enum definition of visibility principal types. */
export enum VisibilityPrincipalType {
    User = 0,
    Group = 1,
}

/** Data object of workflow schema definition. */
export interface WorkflowSchema {
    /** Gets or sets workflow schema version, support ["v1.0", "v2.0"], latest should be v2.0. */
    Version?: string | undefined;
    /** Gets or sets the approvers, default to null. */
    Approvers?: PeopleResult[] | undefined;
    /** Gets or sets a value indicating whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond: boolean;
    /** Gets or sets a value indicating whether the requests created by this template is of CustomResponse type. */
    IsCustomResponseEnabled: boolean;
    /** Gets or sets the custom response options to use when create requests using this template instance. */
    CustomResponseOptions?: string[] | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance.
Support start from WorkflowSchema v2.0. */
    RouteTypes?: RouteTypes | undefined;
    /** Gets or sets the dynamic route if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    DynamicRoute?: DynamicRoute | undefined;
    /** Gets or sets the static routes (solid approvers) if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    StaticRoute?: StaticRoute | undefined;
    /** Gets or sets the fallback policy of the dynamic route. */
    FallbackPolicy?: FallbackPolicy | undefined;
    /** Gets or sets approval steps settings. */
    StepRoutes?: StepRouteSetting[] | undefined;
}

/** Data object representing people results. */
export interface PeopleResult {
    /** Gets or sets the person/user's User's Display Name. */
    UserDisplayName?: string | undefined;
    /** Gets or sets the person/user's AAD Object ID. */
    UserAadObjectId?: string | undefined;
    /** Gets or sets the person/user's UPN. */
    UserUPN?: string | undefined;
    /** Gets or sets the person/user's email. */
    Email?: string | undefined;
    /** Gets or sets the type including class and subclass of the persona. */
    PersonType: PersonType;
}

/** The PersonType Graph Object. */
export interface PersonType {
    /** Gets or sets the id of a Person. */
    Class: string;
    /** Gets or sets the person display name, keep this string and not SubclassTypeEnum
as we donot have the full list of possible values in SubclassTypeEnum. De-serialization will fail. */
    Subclass: string;
}

/** The enum definition of TemplateApproverRouteTypes of WorkflowSchema. */
export enum RouteTypes {
    LetUserEnter = 1,
    StaticRoute = 2,
    DynamicRoute = 4,
    StepRoute = 8,
}

/** The class definition of DynamicRoutes of WorkflowSchema. */
export interface DynamicRoute {
    /** Gets or sets a value indicating whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond: boolean;
    /** Gets or sets the DynamicRoute items. */
    Items?: DynamicRouteItem[] | undefined;
}

/** The base class definition of ResolveResult of DynamicRoute, StaticRoute. */
export interface RouteResolveResult {
    /** Gets or sets a value indicating the result status of the resolution of a template approver routes. */
    ResultCode: RouteResolveResultCode;
}

/** The data model of DynamicRouteItem. */
export interface DynamicRouteItem extends RouteResolveResult {
    /** Gets or sets the type of the dynamic route. */
    Type: DynamicRouteType;
    /** Gets or sets the additional properties of the DynamicRoute. */
    AdditionalProperties?: { [key: string]: string; } | undefined;
    /** Gets or sets a value indicating the resolved approvers from the dynamic route. */
    Approvers?: PeopleResult[] | undefined;
    /** Gets or sets a team Id when DynamicRouteType is TeamWorkTag. */
    TeamId?: string | undefined;
    /** Gets or sets a team tag Id when DynamicRouteType is TeamWorkTag. */
    TeamTagId?: string | undefined;
    /** Gets or sets a team tag displayName when DynamicRouteType is TeamWorkTag. */
    TeamTagDisplayName?: string | undefined;
    /** Gets or sets a team tag memberCount when DynamicRouteType is TeamWorkTag. */
    TeamTagMemberCount?: number | undefined;
}

/** The enum definition of Type of DynamicRoute. */
export enum DynamicRouteType {
    DirectManager = 0,
    TeamWorkTag = 1,
}

/** The enum definition of ResultCode of RouteResolveResult. */
export enum RouteResolveResultCode {
    Unresolved = 0,
    Success = 1,
    ApproverNotFound = 2,
    DirectManagerNotFound = 3,
    UnknownError = 999,
}

/** The class definition of StaticRoute of WorkflowSchema. */
export interface StaticRoute {
    /** Gets or sets a value indicating whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond: boolean;
    /** Gets or sets the resolve result of the static route, return when we resolve a route. */
    ResolveResult?: PredefinedApproversRouteResolveResult[] | undefined;
}

/** The class definition of ResolveResult of predefined approvers. */
export interface PredefinedApproversRouteResolveResult extends RouteResolveResult {
    /** Gets or sets the UserAadObjectId of the approver. */
    ApproverId: string;
    /** Gets or sets the resolved PeopleResult of the approver. */
    Approver?: PeopleResult | undefined;
}

/** The class definition of FallbackPolicy of DynamicRoute. */
export interface FallbackPolicy {
    /** Gets or sets the type of a fallback policy. */
    Type: FallbackPolicyType;
    /** Gets or sets the fallback approvers. */
    FallbackApprovers?: PredefinedApproversRouteResolveResult[] | undefined;
    /** Gets or sets a value indicating whether fallback approvers all must respond. */
    FallbackApproversAllMustRespond?: boolean | undefined;
}

/** The enum definition of Type of FallbackPolicy. */
export enum FallbackPolicyType {
    LetUserEnter = 0,
    FallbackApprovers = 1,
}

/** Setting for create approvers for each sequential approval step. */
export interface StepRouteSetting {
    /** Gets or sets workflow schema version, support ["v1.0", "v2.0"], latest should be v2.0. */
    Version?: string | undefined;
    /** Gets or sets whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond?: boolean | undefined;
    /** Gets or sets a value indicating whether the requests created by this template is of CustomResponse type. */
    IsCustomResponseEnabled?: boolean | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance. */
    CustomResponseOptions?: string[] | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance.
Support start from WorkflowSchema v2.0. */
    RouteTypes?: RouteTypes | undefined;
    /** Gets or sets the dynamic routes if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    DynamicRoute?: DynamicRoute | undefined;
    /** Gets or sets the static routes (solid approvers) if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    StaticRoute?: StaticRoute | undefined;
    /** Gets or sets the fallback policy of the dynamic route. */
    FallbackPolicy?: FallbackPolicy | undefined;
}

/** Data model of the input when creating ApprovalTemplateInstanceInput. */
export interface CreateApprovalTemplateInstanceBaseInput {
    /** Gets or sets the title of the template instance. */
    Title?: string | undefined;
    /** Gets or sets the description of the template instance. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the template instance. */
    IconName?: string | undefined;
    /** Gets or sets the icon color of the template instance. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the template instance. */
    Category: ApprovalTemplateCategory;
    /** Gets or sets the scope of the template instance. */
    Scope: ApprovalTemplateInstanceScopeType;
    /** Gets or sets the teamId of the template instance. this is actually the groupId of the team, and this field is only for Team scoped template instances. */
    TeamId?: string | undefined;
    /** Gets or sets a value indicating whether the template instance is enabled. */
    IsEnabled: boolean;
    /** Gets or sets a value indicating whether the template instance is visible to all organization users, this property is ignored for team scoped template instances. */
    IsVisibleToAll: boolean;
    /** Gets or sets the principals to which the template instance is visible, this field is only for Organization scoped template instances. */
    VisibleTo?: VisibilityPrincipalInput[] | undefined;
    /** Gets or sets the WorkflowSchema. */
    WorkflowSchema?: WorkflowSchemaInput | undefined;
    /** Gets or sets a value indicating whether the file attachment is required. */
    IsFileAttachmentRequired: boolean;
    /** Gets or sets whether the requests created by this template requires approvers comments, default to null. */
    IsApproverCommentsRequired?: boolean | undefined;
}

/** Body input when calling CreateApprovalTemplateInstance controller. */
export interface CreateApprovalTemplateInstanceInput extends CreateApprovalTemplateInstanceBaseInput {
    /** Gets or sets the Id of form. */
    FormId?: string | undefined;
}

/** Data object of the visibility principal definition. */
export interface VisibilityPrincipalInput {
    /** Gets or sets the id of the principal.
AadObjectId for User and Group
Guid.Empty for Everyone. */
    PrincipalId: string;
    /** Gets or sets the principal type. */
    PrincipalType: VisibilityPrincipalType;
}

/** Data object of workflow schema definition. */
export interface WorkflowSchemaInput {
    /** Gets or sets workflow schema version, support ["v1.0", "v2.0"], latest should be v2.0. */
    Version?: string | undefined;
    /** Gets or sets the approvers, default to null. */
    Approvers?: string[] | undefined;
    /** Gets or sets whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond?: boolean | undefined;
    /** Gets or sets a value indicating whether the requests created by this template is of CustomResponse type. */
    IsCustomResponseEnabled?: boolean | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance. */
    CustomResponseOptions?: string[] | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance.
Support start from WorkflowSchema v2.0. */
    RouteTypes?: RouteTypes | undefined;
    /** Gets or sets the dynamic routes if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    DynamicRoute?: DynamicRouteInput | undefined;
    /** Gets or sets the static routes (solid approvers) if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    StaticRoute?: StaticRouteInput | undefined;
    /** Gets or sets the fallback policy of the dynamic route. */
    FallbackPolicy?: FallbackPolicyInput | undefined;
    /** Gets or sets approval steps settings. */
    StepRoutes?: StepRouteSettingInput[] | undefined;
}

/** The data model of DynamicRoute input. */
export interface DynamicRouteInput {
    /** Gets or sets a value indicating whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond?: boolean | undefined;
    /** Gets or sets the DynamicRoute items.
Current we only support 1 dynamic route item, but use array for future feature extensibility. */
    Items?: DynamicRouteItemInput[] | undefined;
}

/** The data model of DynamicRouteItem input. */
export interface DynamicRouteItemInput {
    /** Gets or sets the type of the dynamic route. */
    Type: DynamicRouteType;
    /** Gets or sets the additional properties of the DynamicRoute. */
    AdditionalProperties?: { [key: string]: string; } | undefined;
    /** Gets or sets the team tag Id when DynamicRouteType is TeamWorkTag. */
    TeamTagId?: string | undefined;
}

/** The data model of StaticRoute input. */
export interface StaticRouteInput {
    /** Gets or sets the approvers of the static route. */
    Approvers?: string[] | undefined;
    /** Gets or sets a value indicating whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond?: boolean | undefined;
}

/** The data model of FallBackPolicy input. */
export interface FallbackPolicyInput {
    /** Gets or sets the type of a fallback policy. */
    Type: FallbackPolicyType;
    /** Gets or sets the fallback approvers. */
    FallbackApprovers?: string[] | undefined;
    /** Gets or sets a value indicating whether fallback approvers all must respond. */
    FallbackApproversAllMustRespond?: boolean | undefined;
}

/** Setting for create approvers for each sequential approval step. */
export interface StepRouteSettingInput {
    /** Gets or sets workflow schema version, support ["v1.0", "v2.0"], latest should be v2.0. */
    Version?: string | undefined;
    /** Gets or sets whether the requests created by this template requires all approvers to respond, default to null. */
    AllMustRespond?: boolean | undefined;
    /** Gets or sets a value indicating whether the requests created by this template is of CustomResponse type. */
    IsCustomResponseEnabled?: boolean | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance. */
    CustomResponseOptions?: string[] | undefined;
    /** Gets or sets the custom response options to use when create requests using this template instance.
Support start from WorkflowSchema v2.0. */
    RouteTypes: RouteTypes;
    /** Gets or sets the dynamic routes if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    DynamicRoute?: DynamicRouteInput | undefined;
    /** Gets or sets the static routes (solid approvers) if the template instance creator set any, null if not set.
Support start from WorkflowSchema v2.0. */
    StaticRoute?: StaticRouteInput | undefined;
    /** Gets or sets the fallback policy of the dynamic route. */
    FallbackPolicy?: FallbackPolicyInput | undefined;
}

/** Data object of self owned Approval template instance. */
export interface SelfOwnedApprovalTemplateInstance extends BaseApprovalTemplateInstance {
    /** Gets or sets the questions of the Template. */
    Questions?: Question[] | undefined;
}

/** The data model of QuestionView. */
export interface Question {
    /** Gets or sets the Id. */
    Id?: string | undefined;
    /** Gets or sets Title. */
    Title?: string | undefined;
    /** Gets or sets Subtitle. */
    Subtitle?: string | undefined;
    /** Gets or sets a value indicating whether Required. */
    Required: boolean;
    /** Gets or sets QuestionType. */
    QuestionType: TemplateQuestionType;
    /** Gets or sets Order. */
    Order: number;
    /** Gets or sets Tooltip. */
    Tooltip?: string | undefined;
    /** Gets or sets Placeholder. */
    Placeholder?: string | undefined;
    /** Gets or sets QuestionInfo. */
    QuestionInfo?: string | undefined;
    /** Gets or sets RTQuestionTitle. */
    RTQuestionTitle?: string | undefined;
    /** Gets or sets RTQuestionSubTitle. */
    RTQuestionSubtitle?: string | undefined;
}

/** Quesiton Type. Save and transfer this data as string. [EnumMember(Value = "xx")] dose not work with System.Text.Json. So we use under line to split subtype.the enum filed name cannot be changed once published. */
export enum TemplateQuestionType {
    TextField_Single = "TextField_Single",
    TextField_Multiline = "TextField_Multiline",
    Choice_SingleRadio = "Choice_SingleRadio",
    Choice_SingleDropdown = "Choice_SingleDropdown",
    Choice_MultiCheckbox = "Choice_MultiCheckbox",
    DateTime_Default = "DateTime_Default",
    TextField_Number = "TextField_Number",
}

/** Body input when calling CreateSelfOwnedApprovalTemplateInstanceInput controller. */
export interface CreateSelfOwnedApprovalTemplateInstanceInput extends CreateApprovalTemplateInstanceBaseInput {
    /** Gets or sets the questions of the Template. */
    Questions?: QuestionInput[] | undefined;
}

/** Data object of the template question. */
export interface QuestionInput {
    /** Gets or sets Title. */
    Title?: string | undefined;
    /** Gets or sets Subtitle. */
    Subtitle?: string | undefined;
    /** Gets or sets a value indicating whether Required. */
    Required: boolean;
    /** Gets or sets QuestionType. */
    QuestionType: TemplateQuestionType;
    /** Gets or sets Order. */
    Order: number;
    /** Gets or sets Tooltip. */
    Tooltip?: string | undefined;
    /** Gets or sets Placeholder. */
    Placeholder?: string | undefined;
    /** Gets or sets QuestionInfo. */
    QuestionInfo?: string | undefined;
    /** Gets or sets RTQuestionTitle. */
    RTQuestionTitle?: string | undefined;
    /** Gets or sets RTQuestionSubTitle. */
    RTQuestionSubtitle?: string | undefined;
}

/** Body output when calling CreateAdminGroup controller. */
export interface CreateAdminGroupOutput {
    /** Gets or sets the group id. */
    GroupId?: string | undefined;
    /** Gets or sets the group name. */
    GroupName?: string | undefined;
}

/** Enum definition of different scenarios when get ApprovalTemplateInstance details. */
export enum GetApprovalTemplateInstanceDetailsScenario {
    Management = 0,
    View = 1,
}

/** Data object of the template promotion. */
export interface PromotionInfo {
    /** Gets or sets the new batch tag. */
    Tag?: string | undefined;
    /** Gets or sets the expired time. */
    ExpiredTime: string;
}

/** The class model of user profile. */
export interface UserProfile {
    /** Gets or sets a value indicating whether current user is admin or not. */
    IsAdmin: boolean;
}

/** Data object of Approval template. */
export interface ApprovalTemplate {
    /** Gets or sets the Id of the default template. */
    Id?: string | undefined;
    /** Gets or sets the title of the default template. */
    Title?: string | undefined;
    /** Gets or sets the description of the default template. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the default template. */
    IconName?: string | undefined;
    /** Gets or sets the tag the default template. */
    Tag?: string | undefined;
    /** Gets or sets the icon color of the default template. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the default template. */
    Category: ApprovalTemplateCategory;
    /** Gets or sets the json string of Form template. */
    FormTemplate?: string | undefined;
}

/** Enum definition of different scenarios when listing ApprovalTemplateInstances. */
export enum ListApprovalTemplateInstancesScenario {
    Management = 0,
    View = 1,
}

/** Data model of the output of ListTeamApprovalTemplateInstancesBatch. */
export interface ListTeamApprovalTemplateInstancesBatchOutput {
    /** Gets or sets the list of ListTeamApprovalTemplateInstancesBatchResponse. */
    Responses?: ListTeamApprovalTemplateInstancesBatchResponse[] | undefined;
}

/** Data model of the response of ListTeamApprovalTemplateInstanceBatch requests. */
export interface ListTeamApprovalTemplateInstancesBatchResponse {
    /** Gets or sets the teamId. */
    TeamId: string;
    /** Gets or sets the status of the response. */
    Status: ListTeamApprovalTemplateInstancesStatus;
    /** Gets or sets the list of ApprovalTemplateInstance of the response. */
    Data?: ApprovalTemplateInstance[] | undefined;
}

/** The enum to indicate the status of the ListTeamApprovalTemplateInstancesBatchResponse. */
export enum ListTeamApprovalTemplateInstancesStatus {
    Ok = 0,
    AccessDenied = 1,
    Throttled = 2,
    UnknownError = 999,
}

/** Data model of the input ListTeamApprovalTemplateInstancesBatch. */
export interface ListTeamApprovalTemplateInstancesBatchInput {
    /** Gets or sets the ids of the teams for the batch action. */
    TeamIds?: string[] | undefined;
}

/** Input passed along for the people search APIs. */
export interface PeopleResultsControllerInput {
    /** Gets or sets the query text for the people search. */
    QueryText?: string | undefined;
}

/** Body input when calling UpdateApprovalTemplateInstance controller. */
export interface UpdateApprovalTemplateInstanceInput {
    /** Gets or sets the id of the template instance. */
    Id?: string | undefined;
    /** Gets or sets the title of the template instance. */
    Title?: string | undefined;
    /** Gets or sets the description of the template instance. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the template instance. */
    IconName?: string | undefined;
    /** Gets or sets the icon color of the template instance. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the template instance. */
    Category?: ApprovalTemplateCategory | undefined;
    /** Gets or sets a value indicating whether the template instance is enabled. */
    IsEnabled?: boolean | undefined;
    /** Gets or sets a value indicating whether the template instance is visible to all organization users, this property is ignored for team scoped template instances. */
    IsVisibleToAll?: boolean | undefined;
    /** Gets or sets the principals to which the template instance is visible, this field is only for Organization scoped template instances. */
    VisibleTo?: VisibilityPrincipalInput[] | undefined;
    /** Gets or sets the WorkflowSchema. */
    WorkflowSchema?: WorkflowSchemaInput | undefined;
    /** Gets or sets a value indicating whether the file attachment is required. */
    IsFileAttachmentRequired?: boolean | undefined;
    /** Gets or sets whether the requests created by this template requires approvers comments, default to null. */
    IsApproverCommentsRequired?: boolean | undefined;
}

/** Body input when calling UpdateSelfOwnedApprovalTemplateInstanceInput controller. */
export interface UpdateSelfOwnedApprovalTemplateInstanceInput extends UpdateApprovalTemplateInstanceInput {
    /** Gets or sets the questions of the Template. */
    Questions?: Question[] | undefined;
}

export class ServiceException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isServiceException = true;

    static isServiceException(obj: any): obj is ServiceException {
        return obj.isServiceException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ServiceException(message, status, response, headers, null);
}

/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 *
 *  Base Class for auto-generated nSwag code under `../gen/templates.ts`.
 *  but make sure to run the build of Approvals.SFApp/Approvals.Service to update the auto-generated code, and check in
 *  the auto-generated code as well.
 *
 *  The auto-generated code under `../gen/templates.ts` is the code that actually gets to run.
 */

declare const TEMPLATES_SERVICE_ENDPOINT: string;